export enum PaymentMethod {
  creditCard = 'credit_card',
  openInvoice = 'open_invoice',
  directDebit = 'direct_debit',
  paypal = 'paypal',
  paypalInsFr = 'paypal_ins_fr',
  sofort = 'sofort'
}

export enum PaymentMethodCode {
  creditCard = 'scheme',
  openInvoice = 'openInvoice',
  directDebit = 'directDebit',
  paypal = 'paypal',
  sofort ='directEbanking',
  ideal = 'ideal',
  paypalInsFr = 'paypal_ins_fr'
}

